import styled from "styled-components";

export const Input = styled.input`
  margin-top: 1.8rem;
  width: 75%;
  height: 32px;
  border-radius: 16px;
  padding-left: 1.5rem;
  color: #380f52;
  border: 1px solid;
  border-color: rgba(213, 197, 232, 1);
`;

export const Container = styled.div`
  display: flex;
  width: 18rem;
  height: 12rem;
  flex-direction: column;
  align-items: center;
  background-color: #f6f2f9;
`;
